import { useFormVersionFields } from '@witmetrics/data-store';
import { useFormProvider } from '@/providers/FormProvider';
import Card from '@/components/Card';
import FieldsListItem from './FieldsListItem';
import { classes } from './utils';

export default function FieldsList() {
  const { versionId } = useFormProvider();
  const fields = useFormVersionFields(versionId);

  return (
    <Card className={classes.card}>
      <div className={classes.titleWrapper}>
        <h1 className={classes.title}>Fields</h1>
      </div>
      <ul>
        {fields.map((f) => (
          <FieldsListItem key={f.id} fieldId={f.id} />
        ))}
      </ul>
    </Card>
  );
}
